import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "frisbuy-fashion-tile" }
const _hoisted_2 = {
  ref: "tileWrapper",
  class: "frisbuy-fashion-tile__wrapper"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  ref: "tileTitle",
  class: "frisbuy-fashion-tile__title"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "frisbuy-fashion-tile__hidden-title"
}
const _hoisted_7 = {
  key: 3,
  ref: "tileSubtitle",
  class: "frisbuy-fashion-tile__subtitle"
}
const _hoisted_8 = {
  class: "frisbuy-fashion-tile__kit",
  ref: "tileKit"
}
const _hoisted_9 = { class: "frisbuy-fashion-tile__main-item" }
const _hoisted_10 = { class: "frisbuy-fashion-tile__price-info" }
const _hoisted_11 = { class: "frisbuy-fashion-tile__price" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-fashion-tile__price-title" }, " Цена за комплект ", -1)
const _hoisted_13 = { class: "frisbuy-fashion-tile__price-number" }
const _hoisted_14 = {
  key: 0,
  class: "frisbuy-fashion-tile__add-to-cart"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"21\" viewBox=\"0 0 16 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.07812 6.45703H15.5V18.0742C15.5 18.5259 15.3205 18.9591 15.0011 19.2785C14.6817 19.5979 14.2485 19.7773 13.7968 19.7773H2.78125C2.32955 19.7773 1.89635 19.5979 1.57696 19.2785C1.25756 18.9591 1.07812 18.5259 1.07812 18.0742V6.45703Z\" stroke=\"white\"></path><path d=\"M1.12891 6.50781H15.4492V18.0742C15.4492 18.5124 15.2751 18.9327 14.9652 19.2426C14.6554 19.5525 14.2351 19.7265 13.7969 19.7265H2.78125C2.34302 19.7265 1.92274 19.5525 1.61287 19.2426C1.30299 18.9327 1.12891 18.5124 1.12891 18.0742V6.50781Z\" stroke=\"white\"></path><path d=\"M11.5938 8.71092V4.34103C11.5985 3.4598 11.253 2.61278 10.6332 1.98624C10.0135 1.3597 9.17034 1.00495 8.2891 1C7.40787 1.00495 6.56468 1.3597 5.94496 1.98624C5.32524 2.61278 4.97973 3.4598 4.98442 4.34103V8.71092\" stroke=\"white\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><div class=\"frisbuy-fashion-tile__add-to-cart-title\"> Добавить в корзину </div>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = { class: "products-scoll-block" }
const _hoisted_19 = { class: "frisbuy-fashion-tile__kit-products" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonArrow = _resolveComponent("ButtonArrow")!
  const _component_LikeButton = _resolveComponent("LikeButton")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.titleMode === 'custom' && _ctx.popupSettings?.header?.html)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.popupSettings.header.html,
            class: "frisbuy-fashion-tile__title"
          }, null, 8, _hoisted_3))
        : (_ctx.titleMode !== 'hidden')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.titleMode === 'default')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Готовые комплекты ")
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.titleMode === 'postsCount')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.popupSettings.header.html
                    }, null, 8, _hoisted_5),
                    _createTextVNode(" Посмотрите " + _toDisplayString(_ctx.productsList.length) + " " + _toDisplayString(_ctx.getPluralizationForProductsTitle(_ctx.productsList.length)) + " из образа ", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ], 512))
          : (_openBlock(), _createElementBlock("div", _hoisted_6)),
      (_ctx.titleMode == 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Наводите на товар и переходите в карточку товара ", 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createVNode(_component_ButtonArrow, {
          onClick: _cache[0] || (_cache[0] = () => _ctx.makeEventToChangePost(-1)),
          direction: 'left'
        }, null, 512), [
          [_vShow, _ctx.hasPrevPost]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.productsList.length)
            ? (_openBlock(), _createBlock(_component_LikeButton, {
                key: 0,
                isLiked: _ctx.isFullFavoriteLook,
                onClick: _cache[1] || (_cache[1] = () => _ctx.addProductToFavoriteList(_ctx.productsList, false)),
                style: {
              'z-index': 4,
            }
              }, null, 8, ["isLiked"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "imageArea"),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getTotalPriceForAllProducts(_ctx.productsList)), 1)
            ]),
            false
              ? (_openBlock(), _createElementBlock("button", _hoisted_14, _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_touch, (direction) => _ctx.changePostBySwipe(direction), "swipe"]
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
              return (_openBlock(), _createBlock(_component_ProductItem, {
                key: product.id,
                product: product,
                linkTarget: 
                Boolean(_ctx.popupSettings.targetBlankLink) ? '_blank' : '_self'
              ,
                isLiked: 
                Boolean(
                  _ctx.favoriteVendorList.find((el) =>
                    _ctx.isEqual(el, {
                      article: product.sku?.vendorCode,
                      offerId: product.sku?.offerId,
                      groupId: product.sku?.groupId,
                    })
                  )
                )
              ,
                pinColor: _ctx.popupSettings.image.numberColor,
                isShowPin: _ctx.showUnpinnedNumbers,
                popupText: _ctx.popupText,
                onClickProduct: (product) => _ctx.sendProductAnalytics(product),
                onLike: 
                () => {
                  _ctx.addProductToFavoriteList([product]);
                  _ctx.mouseOver(product, false);
                }
              ,
                onMouseenter: ($event: any) => (_ctx.mouseOver(product, true)),
                onMouseleave: ($event: any) => (_ctx.mouseOver(product, false))
              }, null, 8, ["product", "linkTarget", "isLiked", "pinColor", "isShowPin", "popupText", "onClickProduct", "onLike", "onMouseenter", "onMouseleave"]))
            }), 128))
          ])
        ]),
        _withDirectives(_createVNode(_component_ButtonArrow, {
          onClick: _cache[2] || (_cache[2] = () => _ctx.makeEventToChangePost(1)),
          direction: 'right'
        }, null, 512), [
          [_vShow, _ctx.hasNextPost]
        ])
      ], 512)
    ], 512)
  ]))
}